import {
  createNestablePublicClientApplication,
  InteractionRequiredAuthError,
} from '@azure/msal-browser';

export const OUTLOOK_REPORTER_CLIENT_ID = '31327d6e-a966-46e7-9f10-c27aa01da2a3';

export class ReporterAuthenticationError extends Error {
  constructor(message: string) {
    super(message);
    // Restores the prototype that ES5 output loses, as in ReportSubmissionError.
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export async function getReporterAccessToken(mailbox: string) {
  if (!Office.context.requirements.isSetSupported('NestedAppAuth', '1.1')) {
    throw new ReporterAuthenticationError(
      'This Outlook version needs an update for secure reporting'
    );
  }
  const client = await createNestablePublicClientApplication({
    auth: {
      clientId: OUTLOOK_REPORTER_CLIENT_ID,
      authority: 'https://login.microsoftonline.com/organizations',
    },
    cache: { cacheLocation: 'memoryStorage' },
  });
  const request = {
    scopes: [`api://${OUTLOOK_REPORTER_CLIENT_ID}/report_email`],
    loginHint: mailbox,
  };
  // Tenant-wide consent belongs to administrator setup. Employees never enter a consent popup.
  try {
    const identity = await client.acquireTokenSilent(request);
    if (!identity.account) {
      throw new ReporterAuthenticationError('Office account unavailable');
    }
    const graph = await client.acquireTokenSilent({
      scopes: ['https://graph.microsoft.com/User.Read'],
      account: identity.account,
    });
    return { accessToken: identity.accessToken, graphToken: graph.accessToken };
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      throw new ReporterAuthenticationError('Office authentication needs attention');
    }
    throw error;
  }
}
